<!-- <p-button
	class="btn w-full flex justify-content-center"
	[ngClass]='btclass'
	[severity]="severity"
	[rounded]="rounded"
	[raised]="raised"
	[outlined]="outlined"
	[disabled]="loading || disabled"
	(click)="doAction()">
		<app-loading *ngIf="loading" class="loading-component" extraClass="white small {{ loadingClass }}"></app-loading>
		<i class="fa" [ngClass]='icon'></i>
		<span *ngIf="caption">{{ caption }}</span>
		<span class="subcaption" *ngIf="subcaption">{{ subcaption }}</span>
</p-button> -->

<a
	class="btn btn-mod btn-large btn-round w-full {{ extraClass }}"
	[ngClass]="{ 'disabled': disabled }"
	(click)="disabled ? null : doAction()">
	<app-loading *ngIf="loading" class="loading-component" extraClass="white small {{ loadingClass }}"></app-loading>
	<i class="fa" [ngClass]='icon'></i>
	<span *ngIf="caption">{{ caption }}</span>
</a>
